/* Fixed atlas: interaction never changes the geographic view. */
(function () {
    document.querySelectorAll('[data-history-atlas]').forEach(function (root) {
        var stage=root.querySelector('[data-atlas-stage]');
        var links=Array.from(root.querySelectorAll('[data-atlas-region]'));
        var select=root.querySelector('[data-atlas-destination]'),panel=root.querySelector('[data-atlas-panel]');
        var tooltip=root.querySelector('[data-atlas-tooltip]'),status=root.querySelector('[data-atlas-status]');
        var closeTimer,lastTrigger=null;
        var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
        function highlight(slug,className) {
            links.forEach(function(link){link.classList.toggle(className,link.dataset.atlasRegion===slug||(slug==='indonesia'&&['kalimantan','sumatra'].indexOf(link.dataset.atlasRegion)!==-1));});
            root.querySelectorAll('[data-atlas-label]').forEach(function(label){label.classList.toggle(className,label.dataset.atlasLabel===slug);});
        }
        function dismiss(returnFocus) {
            clearTimeout(closeTimer);
            if(reduced.matches)panel.hidden=true;
            else {panel.classList.add('is-closing');closeTimer=setTimeout(function(){panel.hidden=true;panel.classList.remove('is-closing');},160);}
            select.value='';highlight(null,'is-selected');tooltip.hidden=true;
            if(returnFocus&&lastTrigger)lastTrigger.focus({preventScroll:true});
        }
        function open(link,trigger) {
            clearTimeout(closeTimer);panel.classList.remove('is-closing');lastTrigger=trigger;tooltip.hidden=true;
            select.value=link.dataset.atlasRegion;highlight(link.dataset.atlasRegion,'is-selected');
            root.querySelector('[data-atlas-group]').textContent=link.dataset.group;
            root.querySelector('[data-atlas-title]').textContent=link.dataset.name;
            root.querySelector('[data-atlas-copy]').textContent=link.dataset.intro;
            root.querySelector('[data-atlas-link]').href=link.getAttribute('href');panel.hidden=false;
            status.textContent=link.dataset.name+'. '+link.dataset.intro+' Explore History link is available below the map.';
        }
        function preview(link,e) {
            if(e.pointerType==='touch'||e.buttons)return;
            highlight(link.dataset.atlasRegion,'is-hovered');
            tooltip.querySelector('strong').textContent=link.dataset.name;
            tooltip.querySelector('span').textContent=link.dataset.intro;tooltip.hidden=false;
            var rect=stage.getBoundingClientRect();
            tooltip.style.left=Math.max(12,Math.min(stage.clientWidth-tooltip.offsetWidth-12,e.clientX-rect.left+18))+'px';
            tooltip.style.top=Math.max(12,Math.min(stage.clientHeight-tooltip.offsetHeight-12,e.clientY-rect.top+18))+'px';
        }
        links.forEach(function(link){
            link.addEventListener('pointerenter',function(e){preview(link,e);});
            link.addEventListener('pointermove',function(e){preview(link,e);});
            link.addEventListener('pointerleave',function(){tooltip.hidden=true;highlight(null,'is-hovered');});
            link.addEventListener('focus',function(){highlight(link.dataset.atlasRegion,'is-hovered');});
            link.addEventListener('blur',function(){highlight(null,'is-hovered');});
            link.addEventListener('dragstart',function(e){e.preventDefault();});
            link.addEventListener('click',function(e){
                if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
                e.preventDefault();open(link,link);
                if(e.detail===0)root.querySelector('[data-atlas-link]').focus({preventScroll:true});
            });
        });
        select.addEventListener('change',function(){var link=links.find(function(l){return l.dataset.atlasRegion===select.value;});if(link)open(link,select);else dismiss(false);});
        root.querySelector('[data-atlas-close]').addEventListener('click',function(){dismiss(true);});
        root.addEventListener('keydown',function(e){if(e.key==='Escape')dismiss(true);});
        root.querySelector('[data-atlas-controls]').hidden=false;
        root.querySelector('[data-atlas-enhanced]').hidden=false;
    });
})();
